import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HTTP, HTTPResponse } from '@ionic-native/http';
import 'rxjs/add/operator/toPromise';
import { VariablesProvider } from '../../providers/variables/variables';
import { AlertController } from 'ionic-angular';
import { App } from 'ionic-angular';
//import { ViewController } from 'ionic-angular';
import { HomePage } from '../../pages/home/home';
import { LoginPage } from '../../pages/login/login';
import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ViewChild } from '@angular/core';
import { Events } from 'ionic-angular';


import 'rxjs/add/operator/map';

// Decorator to tell Angular that this class can be injected as a service to another class
@Injectable()

export class FuncionesProvider {

  AppserviciosProvider: any = [];
  prueba;


  constructor(

  	public appCtrl: App,
	private alertCtrl: AlertController,
	//public changeDetector: ChangeDetectorRef,
  	public http: Http,
  	public variables: VariablesProvider,
	private storage: Storage,
  	) {
    
    

 }


 obtenerVacacionesTipos() {

	return new Promise(
	  resolve => {
  
		let user = this.variables.CLIENTES_RAZSOCIAL;
  
		this.http.get(
		  "https://www.panel-control.com/picademo/recursos/sublogin.php/vacacionestipos/" + encodeURIComponent(user)
		)
		.map(res => res.json())
		.subscribe(
		  data => {
			resolve(data);
		  },
		  err => {
			console.log(err);
			resolve([
			  {
				RESULTADO: "ERROR",
				MENSAJE: "Error obteniendo tipos de vacaciones"
			  }
			]);
		  }
		);
  
	  }
	);
  
  }


  guardarVacacionesTipo(datos) {

	return new Promise(
	  resolve => {
  
		if (!datos) {
		  datos = {};
		}
  
		if (!datos.user || datos.user == '') {
		  datos.user = this.variables.CLIENTES_RAZSOCIAL;
		}

		console.log("LLega" + datos.user );
		console.log("LLega2" + this.variables.CLIENTES_RAZSOCIAL );
  
		this.http.put(
		  "https://www.panel-control.com/picademo/recursos/sublogin.php/guardarvacacionestipo",
		  datos
		)
		.map(res => res.json())
		.subscribe(
		  data => {
			resolve(data);
		  },
		  err => {
			console.log(err);
			resolve([
			  {
				RESULTADO: "ERROR",
				MENSAJE: "Error guardando tipo de vacaciones"
			  }
			]);
		  }
		);
  
	  }
	);
  
  }

  borrarVacacionesTipo(id) {

	return new Promise(
	  resolve => {
  
	  
		this.http.get(
		  "https://www.panel-control.com/picademo/recursos/sublogin.php/borrarvacacionestipo/" + id
		)
		.map(res => res.json())
		.subscribe(
		  data => {
			resolve(data);
		  },
		  err => {
			console.log(err);
			resolve([
			  {
				RESULTADO: "ERROR",
				MENSAJE: "Error borrando tipo"
			  }
			]);
		  }
		);
  
	  }
	);
  
  }

situaciondeldia(dia,trabajador,objeto){
	    var datoss = {};
	    datoss["dia"] = dia;
	    datoss["trabajador"] = trabajador;
	    datoss["objeto"] = objeto;

	    var valordevuelto;
	    var headers = new Headers();
	    headers.append("Accept", 'application/json');
	    headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    let options = new RequestOptions({ headers: headers });
	    return new Promise( 
	      resolve=>{
	        this.http.put("https://www.panel-control.com/picademo/recursos/reservas.php/situaciondeldia", datoss, options)
	        .map(res=> res.json())
	        .subscribe(
	            data => {
	 

	             resolve(data);
	            },
	            err=>{
	              console.log(err);
	             }
	            )
	          });
	  }

	obtenervalor(tabla,campo,id){
		  	return new Promise(
		  		resolve=>{
		  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/obtenervalor/"+tabla+"/"+campo+"/"+id);
		  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/obtenervalor/"+tabla+"/"+campo+"/"+id)
		  			.map(res=> res.json())
		  			.subscribe(
		  				data => {
		  					resolve(data);
		  				},
		  				err=>{
		  					console.log(err);
		  				}
		  			)
		  		}
		  	);
		}


		solicitarrenovacion(filtro){
			return new Promise(
				resolve=>{
					//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/solicitarrenovacion/"+filtro);
					   this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/solicitarrenovacion/"+filtro)
					.map(res=> res.json())
					.subscribe(
						data => {
							resolve(data);
						},
						err=>{
							console.log(err);
						}
					)
				}
			);
	  }



		grabapicada(codigotrabajador,fecha,sentido,hora,obra,tipo){
		  	return new Promise(
		  		resolve=>{
					
					//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/grabapicadamanual/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +codigotrabajador+"/"+fecha+"/"+sentido+"/"+hora+"/"+obra+"/"+tipo);
					
					this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabapicadamanual/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +codigotrabajador+"/"+fecha+"/"+sentido+"/"+hora+"/"+obra+"/"+tipo)
		  			.map(res=> res.json())
		  			.subscribe(
		  				data => {
		  					resolve(data);
		  				},
		  				err=>{
		  					console.log(err);
		  				}
		  			)
		  		}
		  	);
		}



	cerrarsesion(){
	  	return new Promise(
	  		resolve=>{
	  			let alert = this.alertCtrl.create({
					title: 'Cerrar sesión',
					message: '¿Está seguro?',
					cssClass: 'alertCustomCss',
					buttons: [{
					    text: 'No',
					    role: 'No',
					    handler: () => { resolve("no");	 }
					  },{
					    text: 'Si',
					    handler: () => {
					  	
						  	this.variables.username = "";
						    this.variables.logged = false;
						    this.variables.CLIENTES_CONTRASENA = "";
						    this.variables.emailactivo = "";

					        this.storage.set('usuario', '');
					        this.storage.set('pass', '');
				    		
					    	resolve("si");
				     		//this.appCtrl.getRootNav().push(LoginPage);
					    }
					  }
					]
				});
				alert.present();
	  		}
	  	);
	}


getAccesoUser(email){
	  	return new Promise(
	  		resolve=>{
	  		   	//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/usuariosimple/"+email);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/usuariosimple/"+email)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	getsubuser(email){
		return new Promise(
			(resolve, reject)=>{
				//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/getsubuser/"+email);
				   this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/getsubuser/" + encodeURIComponent(String(email || '').trim()))
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
						reject(err);
					}
				)
			}
		);
  }

	getAcceso2(email, contrasena){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/usuario/"+email+"/"+contrasena)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtienefiestas(){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/fiestas/" + this.variables.CLIENTES_RAZSOCIAL);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/fiestas/" + this.variables.CLIENTES_RAZSOCIAL)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	grabarfiesta(dia,mes,nombre,lugar){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/grabarfiestas/tricenter/01/01/gorda");
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabarfiestas/"  + this.variables.CLIENTES_RAZSOCIAL + "/" +dia+"/"+mes+"/"+nombre+"/"+lugar)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editafiesta(id,dia,mes,nombre,lugar){
		return new Promise(
			resolve=>{
				//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/editafiestas/"  + id + "/" +dia+"/"+mes+"/"+nombre+"/"+lugar);
				this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editafiestas/"  + id + "/" +dia+"/"+mes+"/"+nombre+"/"+lugar)
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
					}
				)
			}
		);
	}


	delfiesta(id){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/delfiestas/"+id);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/delfiestas/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}



	obtienetrabajadoresdiaobra(filtro,dia,obra,ordenado,asc){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresdia/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +filtro+"/"+dia+"/"+obra+"/"+ordenado+"/"+asc);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresdia/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +filtro+"/"+dia+"/"+obra+"/"+ordenado+"/"+asc)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtienetrabajadoresparainforme(filtro,dia,obra,ordenado,asc){
	  	return new Promise(
	  		resolve=>{
	  	      this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresparainforme/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +filtro+"/"+dia+"/"+obra+"/"+ordenado+"/"+asc)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
						console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresparainforme/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +filtro+"/"+dia+"/"+obra+"/"+ordenado+"/"+asc);

	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtienetrabajadores(filtro){
	  	return new Promise(
	  		resolve=>{
	  			///* console.log( */"https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadores/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +filtro)
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadores/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtienetrabajadoresticket(filtro,dia1,dia2){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresticket/"+filtro+"/"+dia1+"/"+dia2);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresticket/"+filtro+"/"+dia1+"/"+dia2)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtienetrabajadoresalbaranes(filtro,dia1,dia2){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/trabajadoresalbaranes/"+filtro+"/"+dia1+"/"+dia2)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtieneinformepeq(trabajador,obra,turno,empresa,fechaini,fechafin){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/informepeq/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +trabajador +"/" +obra +"/"+turno+"/"+empresa+"/"+fechaini+"/"+fechafin);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/informepeq/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +trabajador +"/" +obra +"/"+turno+"/"+empresa+"/"+fechaini+"/"+fechafin)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					this.variables.muestragif="si";
	  					this.variables.muestraerror = "no";
	  					resolve(data);
	  				},
	  				err=>{
	  					this.variables.muestraerror = "si";
	  					this.variables.muestragif="no";
	  					//console.log("Muetsra el error es true");
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}




	obtieneinforme(trabajador,obra,turno,empresa,fechaini,fechafin,modo){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/informe/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +trabajador+"/"+obra+"/"+turno+"/"+empresa+"/"+fechaini+"/"+fechafin+"/"+modo);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/informe/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +trabajador+"/"+obra+"/"+turno+"/"+empresa+"/"+fechaini+"/"+fechafin+"/"+modo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					this.variables.muestragif="si";
	  					this.variables.muestraerror = "no";
	  					resolve(data);
	  				},
	  				err=>{
	  					this.variables.muestraerror = "si";
	  					this.variables.muestragif="no";
	  					//console.log("Muetsra el error es true");
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


  // ===================================================
  // TIPOS DE DÍAS / AUSENCIAS
  // ===================================================

  obtenerTiposDias() {
    return new Promise(
      resolve => {

        const user = this.variables.CLIENTES_RAZSOCIAL;

        // console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/vacacionestipos/" + user);

        this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/vacacionestipos/" + user)
        .map(res => res.json())
        .subscribe(
          data => {
            resolve(data);
          },
          err => {
            console.log(err);
          }
        );

      }
    );
  }


  guardarTipoDia(tipo) {

    var datoss = {};

    datoss["user"] = this.variables.CLIENTES_RAZSOCIAL;
    datoss["id"] = tipo.id ? tipo.id : 0;
    datoss["codigo"] = tipo.codigo ? tipo.codigo : "";
    datoss["nombre"] = tipo.nombre ? tipo.nombre : "";
    datoss["dias_anuales"] = tipo.dias_anuales ? tipo.dias_anuales : 0;

    datoss["ilimitado"] =
      (tipo.ilimitado === true || tipo.ilimitado == 1 || tipo.ilimitado == "1") ? 1 : 0;

    datoss["descuenta_saldo"] =
      (tipo.descuenta_saldo === true || tipo.descuenta_saldo == 1 || tipo.descuenta_saldo == "1") ? 1 : 0;

    datoss["visible_app"] =
      (tipo.visible_app === true || tipo.visible_app == 1 || tipo.visible_app == "1") ? 1 : 0;

    datoss["activo"] =
      (tipo.activo === false || tipo.activo == 0 || tipo.activo == "0") ? 0 : 1;

    datoss["color"] = tipo.color ? tipo.color : "#999999";
    datoss["orden"] = tipo.orden ? tipo.orden : 99;

    if (datoss["ilimitado"] == 1) {
      datoss["dias_anuales"] = 0;
      datoss["descuenta_saldo"] = 0;
    }

    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    let options = new RequestOptions({ headers: headers });

    return new Promise(
      resolve => {

        this.http.put(
          "https://www.panel-control.com/picademo/recursos/sublogin.php/guardarvacacionestipo",
          datoss,
          options
        )
        .map(res => res.json())
        .subscribe(
          data => {
            resolve(data);
          },
          err => {
            console.log(err);
          }
        );

      }
    );
  }


  borrarTipoDia(id) {
    return new Promise(
      resolve => {

        const user = this.variables.CLIENTES_RAZSOCIAL;

        // Realmente no borramos, lo desactivamos en PHP
        // console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/borrarvacacionestipo/" + user + "/" + id);

        this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/borrarvacacionestipo/" + user + "/" + id)
        .map(res => res.json())
        .subscribe(
          data => {
            resolve(data);
          },
          err => {
            console.log(err);
          }
        );

      }
    );
  }



	informeobras(trabajador,obra,turno,empresa,fechaini,fechafin,modo){
		return new Promise(
			resolve=>{
				     console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/informeobras/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +trabajador+"/"+obra+"/"+turno+"/"+empresa+"/"+fechaini+"/"+fechafin+"/"+modo);
					 this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/informeobras/"+ this.variables.CLIENTES_RAZSOCIAL + "/" +trabajador+"/"+obra+"/"+turno+"/"+empresa+"/"+fechaini+"/"+fechafin+"/"+modo)
				.map(res=> res.json())
				.subscribe(
					data => {
						this.variables.muestragif="si";
						this.variables.muestraerror = "no";
						resolve(data);
					},
					err=>{
						this.variables.muestraerror = "si";
						this.variables.muestragif="no";
						//console.log("Muetsra el error es true");
						console.log(err);
					}
				)
			}
		);
}

	grabartrabajadores(codigo,nombre,password,empresa,obra,turno,horas,activo,alias,tarjeta){
	  	return new Promise(
	  		resolve=>{
	  			const valores = [this.variables.CLIENTES_RAZSOCIAL, codigo, nombre, password, empresa, obra, turno, horas, activo, alias, tarjeta]
	  			  .map(valor => encodeURIComponent(valor == null ? '' : String(valor)));
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabartrabajadores/" + valores.join('/'))
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	
	editatrabajador2(dataito){
	    var datoss = {};
	    var valordevuelto;
	    var headers = new Headers();
	    headers.append("Accept", 'application/json');
	    headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    let options = new RequestOptions({ headers: headers });
	    return new Promise( 
	      resolve=>{
	        this.http.put("https://www.panel-control.com/picademo/recursos/sublogin.php/editartrabajadores2", dataito, options)
	        .map(res=> res.json())
	        .subscribe(
	            data => {
	 

	             resolve(data);
	            },
	            err=>{
	              console.log(err);
	             }
	            )
	          });
	  }




	editatrabajador(codigo,nombre,empresa,obra,turno,horas,activo,fechaalta,puesto,preciohora){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/editartrabajadores/"+codigo+"/"+nombre+"/"+empresa+"/"+obra+"/"+turno+"/"+horas+"/"+activo+"/"+fechaalta+"/"+puesto+"/"+preciohora);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editartrabajadores/"+codigo+"/"+nombre+"/"+empresa+"/"+obra+"/"+turno+"/"+horas+"/"+activo+"/"+fechaalta+"/"+puesto+"/"+preciohora)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	deltrabajadores(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/deltrabajadores/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtienepuestos(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/puestos/" + this.variables.CLIENTES_RAZSOCIAL + "/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/puestos/" + this.variables.CLIENTES_RAZSOCIAL + "/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtieneincidenciasdelmes(mes){
		return new Promise(
			resolve=>{
				    //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/incidencias/" + this.variables.CLIENTES_RAZSOCIAL + "/"+mes);
				   this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/incidencias/" + this.variables.CLIENTES_RAZSOCIAL + "/"+mes)
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
					}
				)
			}
		);
  }

	obtieneempresas(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/empresas/" + this.variables.CLIENTES_RAZSOCIAL + "/654321123456");
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/empresas/" + this.variables.CLIENTES_RAZSOCIAL + "/654321123456")
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	grabarempresas(nombre,cif){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabarempresas/" + encodeURIComponent(this.variables.CLIENTES_RAZSOCIAL) + "/" + encodeURIComponent(nombre) + "/" + encodeURIComponent(cif || ''))
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editarempresas(codigo,nombre,cif){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarempresas/" + encodeURIComponent(codigo) + "/" + encodeURIComponent(nombre) + "/" + encodeURIComponent(cif || ''))
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	delempresas(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/delempresas/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	

	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtieneobrasconfiltro(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/obras/"+ this.variables.CLIENTES_RAZSOCIAL +"/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/obras/"+ this.variables.CLIENTES_RAZSOCIAL +"/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtieneobras(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/todaslasobras/"+ this.variables.CLIENTES_RAZSOCIAL+"/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/todaslasobras/"+ this.variables.CLIENTES_RAZSOCIAL+"/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	
	obtieneconfiguracion(){
		return new Promise(
			(resolve, reject)=>{
				console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/obtieneconfiguracion/"+ this.variables.CLIENTES_RAZSOCIAL)
				 this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/obtieneconfiguracion/"+ this.variables.CLIENTES_RAZSOCIAL)
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
						reject(err);
					}
				)
			}
		);
  }

  actualizaconfiguracion(valor){
	return new Promise(
		(resolve, reject)=>{
			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/actualizaconfiguracion/"+ this.variables.CLIENTES_RAZSOCIAL + "/"+ valor)
			this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/actualizaconfiguracion/"+ this.variables.CLIENTES_RAZSOCIAL + "/"+ valor)
			.map(res=> res.json())
			.subscribe(
				data => {
					resolve(data);
				},
				err=>{
					console.log(err);
					reject(err);
				}
			)
		}
	);
}

  // Preferencia independiente del informe detallado. Se mantiene separada de
  // PICADA_CIERRE_AUTO para no alterar el comportamiento de instalaciones antiguas.
  obtieneConfiguracionPdfDetalle(){
    return new Promise((resolve, reject) => {
      this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/obtienepdfdetalleconfig/" + this.variables.CLIENTES_RAZSOCIAL)
        .map(res => res.json())
        .subscribe(data => resolve(data), err => { console.log(err); reject(err); });
    });
  }

  actualizaConfiguracionPdfDetalle(valor){
    return new Promise((resolve, reject) => {
      this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/actualizapdfdetalleconfig/" +
        this.variables.CLIENTES_RAZSOCIAL + "/" + (valor ? "1" : "0"))
        .map(res => res.json())
        .subscribe(data => resolve(data), err => { console.log(err); reject(err); });
    });
  }

  obtieneEstadoNovedad(clave){
    return new Promise((resolve, reject) => {
      const cliente = encodeURIComponent(this.variables.CLIENTES_RAZSOCIAL || '');
      const novedad = encodeURIComponent(clave || '');
      this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/obtienenovedadvista/" + cliente + "/" + novedad)
        .map(res => res.json())
        .subscribe(data => resolve(data), err => { console.log(err); reject(err); });
    });
  }

  marcaNovedadVista(clave){
    return new Promise((resolve, reject) => {
      const cliente = encodeURIComponent(this.variables.CLIENTES_RAZSOCIAL || '');
      const novedad = encodeURIComponent(clave || '');
      this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/marcanovedadvista/" + cliente + "/" + novedad)
        .map(res => res.json())
        .subscribe(data => resolve(data), err => { console.log(err); reject(err); });
    });
  }

  actualizaResumenEmail(valor, email) {

	const emailSeguro = encodeURIComponent(email);

	
	//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/actualizaresumenemailconfig/"	+ this.variables.CLIENTES_RAZSOCIAL + "/"		+ valor + "/"		+ emailSeguro)


	return new Promise(resolve => {
  
	  this.http.get(
		"https://www.panel-control.com/picademo/recursos/sublogin.php/actualizaresumenemailconfig/"	+ this.variables.CLIENTES_RAZSOCIAL + "/"		+ valor + "/"		+ emailSeguro
	  )
	  .map(res => res.json())
	  .subscribe(
		data => resolve(data),
		err  => console.log(err)
	  );
  
	});
  }

  obtieneUserEmail(usuario) {
    return new Promise(resolve => {
      this.http.get(
        "https://www.panel-control.com/picademo/recursos/sublogin.php/obtieneuseremail/" + encodeURIComponent(usuario || '')
      )
      .map(res => res.json())
      .subscribe(
        data => resolve(data),
        err => { console.log(err); resolve({ RESULTADO: 'ERROR', EMAIL: '' }); }
      );
    });
  }

  actualizaUserEmail(usuario, email) {
    return new Promise(resolve => {
      this.http.get(
        "https://www.panel-control.com/picademo/recursos/sublogin.php/actualizauseremail/" +
        encodeURIComponent(usuario || '') + "/" + encodeURIComponent(email || '')
      )
      .map(res => res.json())
      .subscribe(
        data => resolve(data),
        err => { console.log(err); resolve({ RESULTADO: 'ERROR' }); }
      );
    });
  }

  obtieneCorreoRecordatorio(usuario) {
    return new Promise(resolve => {
      this.http.get(
        "https://www.panel-control.com/picademo/recursos/sublogin.php/recordaracceso/" + encodeURIComponent(usuario || '')
      )
      .map(res => res.json())
      .subscribe(
        data => resolve(data),
        err => { console.log(err); resolve({ RESULTADO: 'ERROR', EMAIL_MASCARADO: '' }); }
      );
    });
  }

  enviarRecordatorioAcceso(usuario) {
    return new Promise(resolve => {
      this.http.get(
        "https://www.panel-control.com/picademo/recursos/sublogin.php/enviarrecordatorio/" + encodeURIComponent(usuario || '')
      )
      .map(res => res.json())
      .subscribe(
        data => resolve(data),
        err => { console.log(err); resolve({ RESULTADO: 'ERROR' }); }
      );
    });
  }
  
  obtieneResumenEmail() {



	return new Promise(resolve => {
  
	  this.http.get(
		"https://www.panel-control.com/picademo/recursos/sublogin.php/obtieneresumenemailconfig/" + this.variables.CLIENTES_RAZSOCIAL 
		
	  )
	  .map(res => res.json())
	  .subscribe(
		data => resolve(data),
		err  => console.log(err)
	  );
  
	});
  }
  


	grabarobras(nombre,activo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabarobras/"+ this.variables.CLIENTES_RAZSOCIAL+"/"+nombre+"/"+activo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editarobras(codigo,nombre,activo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarobras/"+codigo+"/"+nombre+"/"+activo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	delobras(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/delobras/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  	

	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtenerZonaObra(obra){
		return new Promise((resolve, reject) => {
			this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/zonagps/" +
				this.variables.CLIENTES_RAZSOCIAL + "/" + encodeURIComponent(obra))
				.map(res => res.json())
				.subscribe(data => resolve(data), err => reject(err));
		});
	}

	guardarZonaObra(obra, modo, puntos){
		return new Promise((resolve, reject) => {
			const datos = new URLSearchParams();
			datos.set('padre', this.variables.CLIENTES_RAZSOCIAL);
			datos.set('obra', obra);
			datos.set('modo', modo);
			datos.set('puntos', JSON.stringify(puntos || []));
			const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
			this.http.post('https://www.panel-control.com/picademo/recursos/sublogin.php/guardazonagps', datos.toString(), { headers: headers })
				.map(res => res.json())
				.subscribe(data => resolve(data), err => reject(err));
		});
	}



obtieneusers(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/todoslosusers/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/todoslosusers/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	grabarusers(nombre, pass ,valor, valor2){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabaruser/"+nombre+"/"+pass+"/"+valor+"/"+valor2)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	

   
editarusers(data){
	
 var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      let options = new RequestOptions({ headers: headers });
      return new Promise( 
        resolve=>{
          //console.log("El array DESPUES" + data);
             this.http.put("https://www.panel-control.com/picademo/recursos/sublogin.php/editarusers", data, options)
          .map(res=> res.json())
          .subscribe(
            data => {
              resolve(data);
              //console.log("El array DESPUES2" + data);
            },
            err=>{
              console.log(err);
            }

          )
        }
      );
}

	delusers(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/delusers/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  

	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	
			);
	}


	obtieneturnos(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/turnos/"+this.variables.CLIENTES_RAZSOCIAL+"/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/turnos/"+this.variables.CLIENTES_RAZSOCIAL+"/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtieneAsignacionesMes(user: string, anio: number, mes: number, trabajador: string) {

		const url = "https://www.panel-control.com/picademo/recursos/sublogin.php/asignaciones/" + user + "/" + anio + "/" + mes +  "/" + trabajador;

		console.log(url);
		return this.http.get(url).map(r => r.json());

	}

	obtieneAsignacionesMesTodas(user: string, anio: number, mes: number) {
		const url = "https://www.panel-control.com/picademo/recursos/sublogin.php/asignacionesmes/" +
			encodeURIComponent(user) + "/" + anio + "/" + mes;
		return this.http.get(url).map(r => r.json());
	}


	guardaAsignaciones(user, fecha, trabajador, turno_id, turno) {
		
		const url = 'https://www.panel-control.com/picademo/recursos/sublogin.php/grabarasignaciones/'+user+"/"+fecha+"/"+trabajador+"/"+turno_id+"/"+turno;
		console.log(url);
		return new Promise(
			resolve=>{
				this.http.get(url)
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
					}
				)
			}
		);
	}
	
	  
	grabarturnos(nombre,hora_entrada,cortesia,hora_salida,hora_aviso,l,m,x,j,v,s,d,almuerzo,cena){
	  	return new Promise(
	  		resolve=>{
	  			this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/grabarturnos/"+this.variables.CLIENTES_RAZSOCIAL+"/"+nombre+"/"+hora_entrada+"/"+cortesia+"/"+hora_salida+"/"+hora_aviso+"/"+l+"/"+m+"/"+x+"/"+j+"/"+v+"/"+s+"/"+d+"/"+almuerzo+"/"+cena)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editarturnos(codigo,nombre,hora_entrada,cortesia,hora_salida,hora_aviso,l,m,x,j,v,s,d,almuerzo,cena,modo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarturnos/"+codigo+"/"+nombre+"/"+hora_entrada+"/"+cortesia+"/"+hora_salida+"/"+hora_aviso+"/"+l+"/"+m+"/"+x+"/"+j+"/"+v+"/"+s+"/"+d+"/"+almuerzo+"/"+cena+"/"+modo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}



	delturnos(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/delturnos/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  					console.log(data)

	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


  obtieneticketsdesc(filtro, FechaIni, FechaFin){
    var datoss = {};
    datoss["filtro"] = filtro;
    datoss["fechaini"] = FechaIni;
    datoss["fechafin"] = FechaFin;

    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    return new Promise(
    resolve=>{
    //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/ticketsdesc");
    this.http.put("https://www.panel-control.com/picademo/recursos/sublogin.php/ticketsdesc", datoss ,options)
          .map(
          	res=> res.json()
          	)
          .subscribe(
            data => {
              resolve(data);
            },
            err=>{
              alert(err);
            }
          )
         }
      );
    }
    obtieneticketsdias(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/ticketsdias/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/ticketsdias/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}
	obtienealbaranesdias(filtro){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/albaranesdias/"+filtro);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/albaranesdias/"+filtro)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}
	obtieneticketsdesc2(filtro, FechaIni, FechaFin){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/ticketsdesc/"+filtro+"/"+FechaIni+"/"+FechaFin);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/ticketsdesc/"+filtro+"/"+FechaIni+"/"+FechaFin)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


  obtienealbaranesdesc(filtro, FechaIni, FechaFin){
    var datoss = {};
    datoss["filtro"] = filtro;
    datoss["fechaini"] = FechaIni;
    datoss["fechafin"] = FechaFin;

    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    return new Promise(
    resolve=>{
    //console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/albaranesdesc");
    this.http.put("https://www.panel-control.com/picademo/recursos/sublogin.php/albaranesdesc", datoss ,options)
          .map(
          	res=> res.json()
          	)
          .subscribe(
            data => {
              resolve(data);
            },
            err=>{
              alert(err);
            }
          )
         }
      );
    }

	obtienealbaranesdesc2(filtro, FechaIni, FechaFin){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/albaranesdesc/"+filtro+"/"+FechaIni+"/"+FechaFin);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/albaranesdesc/"+filtro+"/"+FechaIni+"/"+FechaFin)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtienepicajesdesc(filtro, dia){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesdesc/"+filtro+"/"+dia);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesdesc/"+filtro+"/"+dia)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtienepicajesdescestudio(filtro, dia){
		return new Promise((resolve, reject) => {
			this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesdescestudio/" + filtro + "/" + dia)
				.map(res => res.json())
				.subscribe(data => resolve(data), err => {
					// Hasta publicar la API nueva, la pantalla sigue funcionando con la
					// lectura historica, aunque todavia no muestre el estudio.
					this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesdesc/" + filtro + "/" + dia)
						.map(res => res.json())
						.subscribe(data => resolve(data), error => reject(error));
				});
		});
	}

	obtienepicajes(filtro, dia){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/picajes/"+filtro+"/"+dia);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/picajes/"+filtro+"/"+dia)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	/*
	 * Prepara solamente los datos del listado y de los informes cuando una
	 * jornada cruza medianoche. No escribe nada en la tabla picajes: crea
	 * filas virtuales 24:00/00:00 para que cada fecha tenga un tramo completo.
	 */
	normalizarJornadasMedianoche(filas: any[], codigo?: string, fechaInicio?: string, fechaFin?: string, forzarContexto: boolean = false){
		const resultado: any[] = Array.isArray(filas) ? filas : [];
		if (!resultado.length || !this.obtienepicajes) { return Promise.resolve(resultado); }

		const fechaValida = (valor: any): boolean => /^\d{4}-\d{2}-\d{2}$/.test(String(valor || '').substr(0, 10));
		const minutosHora = (valor: any): number | null => {
			const partes = /^(\d{1,2}):(\d{2})/.exec(String(valor || '').trim());
			if (!partes) { return null; }
			const horas = Number(partes[1]);
			const minutos = Number(partes[2]);
			if (horas > 24 || minutos > 59 || (horas === 24 && minutos !== 0)) { return null; }
			return horas * 60 + minutos;
		};
		const fechaDesplazada = (fecha: string, dias: number): string => {
			const instante = Date.parse(fecha + 'T00:00:00Z');
			if (!isFinite(instante)) { return ''; }
			const dia = new Date(instante + dias * 86400000);
			return dia.getUTCFullYear() + '-' + ('0' + (dia.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + dia.getUTCDate()).slice(-2);
		};
		const fechaDeFila = (fila: any): string => String(fila && fila.FECHA || '').substr(0, 10);
		const codigoDeFila = (fila: any): string => String(fila && fila.CODIGO || '').trim();
		const clave = (valorCodigo: string, fecha: string): string => valorCodigo + '|' + fecha;
		const esSalida = (fila: any): boolean => ['sal', 'sale', 'salida'].indexOf(String(fila && fila.SENTIDO || '').trim().toLowerCase()) >= 0;
		const esEntrada = (fila: any): boolean => ['ent', 'entra', 'entrada'].indexOf(String(fila && fila.SENTIDO || '').trim().toLowerCase()) >= 0;

		const codigos: string[] = [];
		resultado.forEach(fila => {
			const valor = codigoDeFila(fila) || String(codigo || '').trim();
			if (valor && codigos.indexOf(valor) < 0) { codigos.push(valor); }
		});
		if (codigo && codigos.indexOf(String(codigo).trim()) < 0) { codigos.push(String(codigo).trim()); }
		if (!codigos.length) { return Promise.resolve(resultado); }

		const cantidadPorFecha: { [clave: string]: number } = {};
		const fechasCandidatas: { [clave: string]: boolean } = {};
		resultado.forEach(fila => {
			const fecha = fechaDeFila(fila);
			const valorCodigo = codigoDeFila(fila) || String(codigo || '').trim();
			if (!fechaValida(fecha) || !valorCodigo) { return; }
			const claveFecha = clave(valorCodigo, fecha);
			cantidadPorFecha[claveFecha] = (cantidadPorFecha[claveFecha] || 0) + 1;
			const inicio = String(fila.PICADA_INICIAL || '').trim();
			const final = String(fila.PICADA_FINAL || '').trim().toLowerCase();
			if (forzarContexto || String(fila.NOMBRE || '').trim().toUpperCase() === 'SAL' ||
				!final || final === 'no' || (inicio && final === inicio.toLowerCase())) {
				fechasCandidatas[claveFecha] = true;
			}
		});
		Object.keys(cantidadPorFecha).forEach(claveFecha => {
			if (cantidadPorFecha[claveFecha] > 1) { fechasCandidatas[claveFecha] = true; }
		});
		if (forzarContexto && fechaValida(fechaInicio)) {
			codigos.forEach(valorCodigo => { fechasCandidatas[clave(valorCodigo, String(fechaInicio).substr(0, 10))] = true; });
		}

		const consultas: any[] = [];
		Object.keys(fechasCandidatas).forEach(claveFecha => {
			const separador = claveFecha.lastIndexOf('|');
			const valorCodigo = claveFecha.substr(0, separador);
			const fecha = claveFecha.substr(separador + 1);
			[-1, 0, 1].forEach(desplazamiento => {
				const fechaConsulta = fechaDesplazada(fecha, desplazamiento);
				const claveConsulta = clave(valorCodigo, fechaConsulta);
				if (fechaConsulta && !consultas.some(c => c.clave === claveConsulta)) {
					consultas.push({ clave: claveConsulta, codigo: valorCodigo, fecha: fechaConsulta });
				}
			});
		});
		if (!consultas.length) { return Promise.resolve(resultado); }

		const leer = (consulta: any): Promise<any[]> => {
			return new Promise(resolve => {
				let terminado = false;
				const temporizador = setTimeout(() => { if (!terminado) { terminado = true; resolve([]); } }, 10000);
				Promise.resolve(this.obtienepicajes(consulta.codigo, consulta.fecha)).then(datos => {
					if (terminado) { return; }
					terminado = true;
					clearTimeout(temporizador);
					resolve(Array.isArray(datos) ? datos : []);
				}, () => {
					if (terminado) { return; }
					terminado = true;
					clearTimeout(temporizador);
					resolve([]);
				});
			});
		};

		return Promise.all(consultas.map(consulta => leer(consulta))).then(respuestas => {
			const eventosPorCodigo: { [codigo: string]: any[] } = {};
			respuestas.forEach((datos, indice) => {
				const consulta = consultas[indice];
				if (!eventosPorCodigo[consulta.codigo]) { eventosPorCodigo[consulta.codigo] = []; }
				(datos || []).forEach((dato, posicion) => {
					const fecha = String(dato && dato.FECHA || consulta.fecha).substr(0, 10);
					const minutos = minutosHora(dato && (dato.HORA || dato.PICADA));
					if (!fechaValida(fecha) || minutos === null || (!esEntrada(dato) && !esSalida(dato))) { return; }
					eventosPorCodigo[consulta.codigo].push({ dato, fecha, minutos, instante: Date.parse(fecha + 'T00:00:00Z') + minutos * 60000, entrada: esEntrada(dato), posicion });
				});
			});

			const cruces: any[] = [];
			Object.keys(eventosPorCodigo).forEach(valorCodigo => {
				const eventos = eventosPorCodigo[valorCodigo].sort((a, b) => a.instante - b.instante || a.posicion - b.posicion);
				let entrada: any = null;
				eventos.forEach(evento => {
					if (evento.entrada) {
						entrada = evento;
					} else if (entrada && evento.instante > entrada.instante) {
						if (entrada.fecha !== evento.fecha) {
							cruces.push({ codigo: valorCodigo, entrada, salida: evento });
						}
						entrada = null;
					}
				});
			});
			const primeraEntradaPorFecha: { [clave: string]: any } = {};
			const minutosSinTrabajarPorFecha: { [clave: string]: number } = {};
			Object.keys(eventosPorCodigo).forEach(valorCodigo => {
				const eventos = eventosPorCodigo[valorCodigo] || [];
				eventos.forEach(evento => {
					if (!evento.entrada) { return; }
					const claveFecha = clave(valorCodigo, evento.fecha);
					if (!primeraEntradaPorFecha[claveFecha] ||
						evento.instante < primeraEntradaPorFecha[claveFecha].instante) {
						primeraEntradaPorFecha[claveFecha] = evento;
					}
				});
				for (let indice = 0; indice < eventos.length - 1; indice++) {
					const salida = eventos[indice];
					const siguienteEntrada = eventos[indice + 1];
					if (salida.entrada || !siguienteEntrada.entrada || salida.fecha !== siguienteEntrada.fecha) { continue; }
					const pausa = Math.max(0, Math.round((siguienteEntrada.instante - salida.instante) / 60000));
					const claveFecha = clave(valorCodigo, salida.fecha);
					minutosSinTrabajarPorFecha[claveFecha] = (minutosSinTrabajarPorFecha[claveFecha] || 0) + pausa;
				}
			});

			const dentroDelRango = (fecha: string): boolean => {
				const inicio = fechaValida(fechaInicio) ? String(fechaInicio).substr(0, 10) : '';
				const fin = fechaValida(fechaFin) ? String(fechaFin).substr(0, 10) : '';
				return (!inicio || fecha >= inicio) && (!fin || fecha <= fin);
			};
			const esFilaUtil = (fila: any): boolean => String(fila && fila.NOMBRE || '').trim().toUpperCase() !== 'SAL';
			const limpiarCalculados = (fila: any): void => {
				['HORAS_TRANSCURRIDAS', 'HORAS_TRABAJADAS', 'HORAS_EXTRAS', 'HORAS_SIN_TRABAJAR', 'HORAS_PARADAS'].forEach(campo => {
					if (fila && Object.prototype.hasOwnProperty.call(fila, campo)) { fila[campo] = ''; }
				});
				// La fila representa picadas reales repartidas entre dos fechas.
				// Evita que el resumen del PDF la descarte como un día sin picajes.
				fila.PICO = 'SI';
				fila._PICADA_VIRTUAL_MEDIANOCHE = true;
			};
			const nombreBase = (valorCodigo: string): string => {
				const fila = resultado.find(f => codigoDeFila(f) === valorCodigo && esFilaUtil(f) && f.NOMBRE);
				return fila ? fila.NOMBRE : '';
			};
			const baseParaFecha = (valorCodigo: string, fecha: string): any => {
				return resultado.find(f => codigoDeFila(f) === valorCodigo && fechaDeFila(f) === fecha && esFilaUtil(f)) ||
					resultado.find(f => codigoDeFila(f) === valorCodigo && esFilaUtil(f)) || {};
			};
			const crearFila = (valorCodigo: string, fecha: string, entradaTexto: string, salidaTexto: string): any => {
				const base = baseParaFecha(valorCodigo, fecha);
				const fila = Object.assign({}, base);
				fila.CODIGO = valorCodigo;
				fila.NOMBRE = nombreBase(valorCodigo) || fila.NOMBRE || '';
				fila.FECHA = fecha;
				fila.PICADA_INICIAL = entradaTexto;
				fila.PICADA_FINAL = salidaTexto;
				fila.SENTIDO = '';
				limpiarCalculados(fila);
				return fila;
			};
			const buscarFila = (valorCodigo: string, fecha: string, hora: string): any => {
				return resultado.find(f => codigoDeFila(f) === valorCodigo && fechaDeFila(f) === fecha && esFilaUtil(f) &&
					(String(f.PICADA_INICIAL || '').trim() === hora || String(f.PICADA_FINAL || '').trim() === hora));
			};

			cruces.forEach(cruce => {
				const fechaEntrada = cruce.entrada.fecha;
				const fechaSalida = cruce.salida.fecha;
				if (dentroDelRango(fechaEntrada)) {
					const primeraEntrada = primeraEntradaPorFecha[clave(cruce.codigo, fechaEntrada)] || cruce.entrada;
					const horaPrimeraEntrada = String(primeraEntrada.dato.HORA || primeraEntrada.dato.PICADA);
					let filaEntrada = buscarFila(cruce.codigo, fechaEntrada, String(cruce.entrada.dato.HORA || cruce.entrada.dato.PICADA));
					if (!filaEntrada) {
						filaEntrada = resultado.find(f => codigoDeFila(f) === cruce.codigo &&
							fechaDeFila(f) === fechaEntrada && esFilaUtil(f));
					}
					if (!filaEntrada) {
						filaEntrada = crearFila(cruce.codigo, fechaEntrada, horaPrimeraEntrada, '24:00');
						resultado.push(filaEntrada);
					} else {
						// Si el día ya empezó virtualmente a las 00:00 porque una
						// jornada venía del día anterior, se conserva ese inicio.
						if (String(filaEntrada.PICADA_INICIAL || '').trim() !== '00:00') {
							filaEntrada.PICADA_INICIAL = horaPrimeraEntrada;
						}
						filaEntrada.PICADA_FINAL = '24:00';
						limpiarCalculados(filaEntrada);
					}
					filaEntrada._MINUTOS_SIN_TRABAJAR_REAL = minutosSinTrabajarPorFecha[clave(cruce.codigo, fechaEntrada)] || 0;
				}
				if (dentroDelRango(fechaSalida)) {
					const horaSalida = String(cruce.salida.dato.HORA || cruce.salida.dato.PICADA);
					let filaSalida = buscarFila(cruce.codigo, fechaSalida, horaSalida);
					if (!filaSalida) {
						filaSalida = crearFila(cruce.codigo, fechaSalida, '00:00', horaSalida);
						resultado.push(filaSalida);
					} else {
						filaSalida.PICADA_INICIAL = '00:00';
						filaSalida.PICADA_FINAL = horaSalida;
						limpiarCalculados(filaSalida);
					}
					const eventosFechaSalida = (eventosPorCodigo[cruce.codigo] || [])
						.filter(evento => evento.fecha === fechaSalida)
						.sort((a, b) => a.instante - b.instante || a.posicion - b.posicion);
					let jornadaAbierta = false;
					eventosFechaSalida.forEach(evento => { jornadaAbierta = !!evento.entrada; });
					if (jornadaAbierta) {
						filaSalida.PICADA_FINAL = '24:00';
						limpiarCalculados(filaSalida);
					} else if (eventosFechaSalida.length) {
						// El día puede contener el cierre de la jornada anterior y, más
						// tarde, otra jornada completa. En ese caso el resumen debe abarcar
						// hasta la última salida real del día; las pausas SAL->ENT se restan
						// mediante _MINUTOS_SIN_TRABAJAR_REAL. Si conserváramos solamente
						// la primera salida, se restaría la pausa de un tramo incompleto y
						// aparecerían horas negativas como "0-12:35".
						const ultimoEvento = eventosFechaSalida[eventosFechaSalida.length - 1];
						if (!ultimoEvento.entrada) {
							filaSalida.PICADA_FINAL = String(ultimoEvento.dato.HORA || ultimoEvento.dato.PICADA);
							limpiarCalculados(filaSalida);
						}
					}
					filaSalida._MINUTOS_SIN_TRABAJAR_REAL = minutosSinTrabajarPorFecha[clave(cruce.codigo, fechaSalida)] || 0;
				}
			});

			return resultado.sort((a, b) => {
				const fechaA = fechaDeFila(a);
				const fechaB = fechaDeFila(b);
				if (fechaA !== fechaB) { return fechaA < fechaB ? -1 : 1; }
				const horaA = minutosHora(a && a.PICADA_INICIAL); const horaB = minutosHora(b && b.PICADA_INICIAL);
				return (horaA === null ? 9999 : horaA) - (horaB === null ? 9999 : horaB);
			});
		});
	}

	obtienepicajesglobal(dia){

		if (this.variables.usuariomapaid){
			////console.log("Mapa con id:" + this.variables.usuariomapaid);
		  	return new Promise(

		  		resolve=>{
		  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesglobalconid/" + this.variables.CLIENTES_RAZSOCIAL + "/" +this.variables.usuariomapaid);
		  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesglobalconid/" + this.variables.CLIENTES_RAZSOCIAL + "/" +this.variables.usuariomapaid)
		  			.map(res=> res.json())
		  			.subscribe(
		  				data => {
		  					resolve(data);
		  				},
		  				err=>{
		  					console.log(err);
		  				}
		  			)
		  		}
		  	);
		
		}else{

			console.log("Mapa sin id");
			  	
		  	return new Promise(
		  		resolve=>{
		  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesglobal/" + this.variables.CLIENTES_RAZSOCIAL + "/" +dia);
		  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/picajesglobal/" + this.variables.CLIENTES_RAZSOCIAL + "/" +dia)
		  			.map(res=> res.json())
		  			.subscribe(
		  				data => {
		  					resolve(data);
		  				},
		  				err=>{
		  					console.log(err);
		  				}
		  			)
		  		}
		  	);
		 }
	}

	delpicada(id){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/delpicada/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  					console.log(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}



	editapicajecompleto(id,hora,obra){
	  	return new Promise(
	  		resolve=>{
	  			if (obra) {
                   // code...
                 }else{
                   obra="654321123456";
                 }
	  			//console.log("https://www.panel-control.com/picademo/recursos/sublogin.php/editarpicajecompleto/"+id+"/"+hora+"/"+obra);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarpicajecompleto/"+id+"/"+hora+"/"+obra)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editapicaje(valor,id){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarpicaje/"+valor+"/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}
	editapicajesentido(valor,id){
		return new Promise(
			resolve=>{
				   this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarpicajesentido/"+valor+"/"+id)
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
					}
				)
			}
		);
  }

	editaticket(id,verificado){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editarticket/"+id+"/"+verificado)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editaalbaran(id,verificado){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/editaralbaran/"+id+"/"+verificado)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

obtenerVehiculosconreserva(trabajador,mes,ano){
	  	return new Promise(
	  		resolve=>{
	  		   	//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenervehiculosconreserva/"+trabajador+"/"+mes+"/"+ano);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenervehiculosconreserva/"+trabajador+"/"+mes+"/"+ano)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

obtenerSalasconreserva(trabajador,mes,ano){
	  	return new Promise(
	  		resolve=>{
	  		   	////console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenersalasconreserva/"+trabajador+"/"+mes+"/"+ano);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenersalasconreserva/"+trabajador+"/"+mes+"/"+ano)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtenerVehiculos(trabajador,mes,ano){
	  	return new Promise(
	  		resolve=>{
	  		   	////console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenervehiculos/"+trabajador+"/"+mes+"/"+ano);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenervehiculos/"+trabajador+"/"+mes+"/"+ano)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}
	obtenerSalas(trabajador,mes,ano){
	  	return new Promise(
	  		resolve=>{
	  		   	////console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenersalas/"+trabajador+"/"+mes+"/"+ano);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenersalas/"+trabajador+"/"+mes+"/"+ano)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}
	obtenerreservas(id,fecha){
	  	return new Promise(
	  		resolve=>{
	  		   	//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservasvehiculos/"+id+"/"+fecha);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservasvehiculos/"+id+"/"+fecha)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}
	obtenerreservassalas(id,fecha){
	  	return new Promise(
	  		resolve=>{
	  		   	//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservassalas/"+id+"/"+fecha);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservassalas/"+id+"/"+fecha)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtenerNombreVehiculo(id){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenernombrevehiculo/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtenerNombreSala(id){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenernombresala/"+id);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenernombresala/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	eliminaReserva(id){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/eliminareserva/"+id);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/eliminareserva/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	eliminaReservaSala(id){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/eliminareservasala/"+id);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/eliminareservasala/"+id)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}



editarreservasalas(dataito){
	    var datoss = {};
	    var valordevuelto;
	    var headers = new Headers();
	    headers.append("Accept", 'application/json');
	    headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    let options = new RequestOptions({ headers: headers });
	    return new Promise( 
	      resolve=>{
	        this.http.put("https://www.panel-control.com/picademo/recursos/reservas.php/editarreservasalas", dataito, options)
	        .map(res=> res.json())
	        .subscribe(
	            data => {
	             resolve(data);
	            },
	            err=>{
	              console.log(err);
	             }
	            )
	          });
	  }


	obtenerReservas(idObjeto,fecha){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservasvehiculos/"+idObjeto+"/"+fecha);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservasvehiculos/"+idObjeto+"/"+fecha)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtenerReservasSalas(idObjeto,fecha){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservassalas/"+idObjeto+"/"+fecha);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/obtenerreservassalas/"+idObjeto+"/"+fecha)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	obtieneobjetos(){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/objetos");
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/objetos")
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	grabarobjetos(nombre,tipo){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/reservas.php/grabarobjetos/"+nombre+"/"+tipo);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/grabarobjetos/"+nombre+"/"+tipo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editarobjetos(codigo,nombre){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/editarobjetos/"+codigo+"/"+nombre)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	delobjetos(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/reservas.php/delobjetos/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	

	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	obtienedatoslicencia(padre){
		return new Promise(
			resolve=>{
				//console.log("https://www.panel-control.com/picademo/recursos/grupos.php/grabargrupos/"+nombre);
				   this.http.get("https://www.panel-control.com/picademo/recursos/sublogin.php/obtienelicencia/"+padre)
				.map(res=> res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err=>{
						console.log(err);
					}
				)
			}
		);
  }




	obtienegrupos(){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/grupos.php/grupos");
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/grupos.php/grupos")
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}


	grabargrupos(nombre){
	  	return new Promise(
	  		resolve=>{
	  			//console.log("https://www.panel-control.com/picademo/recursos/grupos.php/grabargrupos/"+nombre);
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/grupos.php/grabargrupos/"+nombre)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	editargrupos(codigo,nombre){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/grupos.php/editargrupos/"+codigo+"/"+nombre)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
	  		}
	  	);
	}

	delgrupos(codigo){
	  	return new Promise(
	  		resolve=>{
	  		   	this.http.get("https://www.panel-control.com/picademo/recursos/grupos.php/delgrupos/"+codigo)
	  			.map(res=> res.json())
	  			.subscribe(
	  				data => {
	  					resolve(data);
	

	  				},
	  				err=>{
	  					console.log(err);
	  				}
	  			)
		}
	);
	}

	// Endpoint nuevo e independiente para el asistente. No modifica sublogin.php.
	preguntaAgenteIA(pregunta: string, historial: any[] = [], estudio: any = null): Promise<any> {
		const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
		const datos = new URLSearchParams();
		datos.set('pregunta', pregunta);
		datos.set('historial', JSON.stringify(historial || []));
		datos.set('estudio', estudio ? JSON.stringify(estudio) : '');
		datos.set('cliente', this.variables.CLIENTES_RAZSOCIAL || '');
		datos.set('pantalla', 'principal');
		return new Promise((resolve, reject) => {
			this.http.post(
				'https://www.panel-control.com/picademo/recursos/ia-soporte.php/preguntar',
				datos.toString(),
				new RequestOptions({ headers: headers })
			)
			.map(res => res.json())
			.subscribe(data => resolve(data), error => reject(error));
		});
	}

	guardarAprendizajeAhorita(caso: any): Promise<any> {
		const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });
		const seguro: any = Object.assign({}, caso || {}, {
			CLIENTE: this.variables.CLIENTES_RAZSOCIAL || ''
		});
		return new Promise((resolve, reject) => {
			this.http.post(
				'https://www.panel-control.com/picademo/recursos/sublogin.php/ahorita/aprendizajes',
				JSON.stringify(seguro),
				new RequestOptions({ headers: headers })
			)
			.map(res => res.json())
			.subscribe(data => resolve(data), error => reject(error));
		});
	}

	actualizarAprendizajeAhorita(id: any, caso: any): Promise<any> {
		const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });
		const seguro: any = Object.assign({}, caso || {}, { CLIENTE: this.variables.CLIENTES_RAZSOCIAL || '' });
		return new Promise((resolve, reject) => {
			this.http.post(
				'https://www.panel-control.com/picademo/recursos/sublogin.php/ahorita/aprendizajes/' + encodeURIComponent(id) + '/editar',
				JSON.stringify(seguro), new RequestOptions({ headers: headers })
			).map(res => res.json()).subscribe(data => resolve(data), error => reject(error));
		});
	}

	eliminarAprendizajeAhorita(id: any): Promise<any> {
		const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });
		const cuerpo = { CLIENTE: this.variables.CLIENTES_RAZSOCIAL || '' };
		return new Promise((resolve, reject) => {
			this.http.post(
				'https://www.panel-control.com/picademo/recursos/sublogin.php/ahorita/aprendizajes/' + encodeURIComponent(id) + '/eliminar',
				JSON.stringify(cuerpo), new RequestOptions({ headers: headers })
			).map(res => res.json()).subscribe(data => resolve(data), error => reject(error));
		});
	}

	obtenerAprendizajesAhorita(): Promise<any> {
		const usuario = encodeURIComponent(this.variables.CLIENTES_RAZSOCIAL || '');
		return new Promise((resolve, reject) => {
			this.http.get('https://www.panel-control.com/picademo/recursos/sublogin.php/ahorita/aprendizajes/' + usuario)
			.map(res => res.json())
			.subscribe(data => resolve(data), error => reject(error));
		});
	}

	registrarResultadoAprendizajeAhorita(id: any, resultado: 'SUGERIDA' | 'ACIERTO' | 'FALLO'): Promise<any> {
		const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });
		const cuerpo = {
			CLIENTE: this.variables.CLIENTES_RAZSOCIAL || '',
			RESULTADO: resultado
		};
		return new Promise((resolve, reject) => {
			this.http.post(
				'https://www.panel-control.com/picademo/recursos/sublogin.php/ahorita/aprendizajes/' + encodeURIComponent(id) + '/resultado',
				JSON.stringify(cuerpo),
				new RequestOptions({ headers: headers })
			)
			.map(res => res.json())
			.subscribe(data => resolve(data), error => reject(error));
		});
	}
}



// WEBPACK FOOTER //
// ./src/providers/funciones/funciones.ts